import { api } from './client'
import type { CreditsResponse, Plan } from './types'

export const creditsApi = {
  get(page = 1, pageSize = 50): Promise<CreditsResponse> {
    return api.get<CreditsResponse>('/credits', { query: { page, pageSize } })
  },

  /** Returns a hosted checkout URL; the caller navigates the browser to it. */
  purchase(packId: string): Promise<{ checkoutUrl: string }> {
    return api.post<{ checkoutUrl: string }>('/credits/purchase', { packId })
  },

  plans(): Promise<Plan[]> {
    return api.get<Plan[]>('/plans')
  },
}
